// removed by extract-text-webpack-plugin
module.exports = {"Test":"_29LWrSys8ghrk3QcadNnut","Card":"_3kGDNHkOOjEuh5Rw34pPMb","Header":"_3pCZEUDpMNi1RDhew3iF3k","Title":"_36TuZtOOOHsx6XzHtZpiGz","Content":"_5PLiCO-7f9ri6hMzz7PyH","SelectorBlock":"_3bCDcCCxnW8OfDwRNS-K83","TableWrap":"_3cnXhCMvfLf_zS3S5lVkVt"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Refills/styles.module.css
// module id = 644
// module chunks = 0